<template>
  <el-dialog title="报名表专属二维码" :visible.sync="dialogVisible" @close="close" >
    <el-row class="qrcode-box">
      <el-col :span="24" >
        <div style="color:red">使用报名表二维码时请确保学生电话号必须正确</div>
      </el-col>
    </el-row>
    <el-row class="qrcode-box" v-show="imgs.jp">
      <!-- v-permission="[19, 20, 33, 58, 101] -->
      <el-col :span="8" >
        <div>日本报名表专属二维码</div>
        <img :src="imgs.jp" class="qrcode-img" v-show="imgs.jp">
        <el-button type="primary" @click="download(imgs.jp, '日本报名表专属二维码.png')">下载</el-button>
      </el-col>
      <!-- v-permission="[22, 54, 135, 136]" -->
      <el-col :span="8">
        <div>韩国报名表专属二维码</div>
        <img :src="imgs.ko" class="qrcode-img" v-show="imgs.ko">
        <el-button type="primary" @click="download(imgs.ko, '韩国报名表专属二维码.png')">下载</el-button>
      </el-col>
      <el-col :span="8">
        <div>新加坡&马来西亚报名表专属二维码</div>
        <img :src="imgs.sg" class="qrcode-img" v-show="imgs.sg">
        <el-button type="primary" @click="download(imgs.sg, '新加坡&马来西亚报名表专属二维码.png')">下载</el-button>
      </el-col>
    </el-row>
    <el-row class="qrcode-box" v-show="imgs.qc">
      <el-col :span="8">
        <div>前程信息采集专属二维码</div>
        <img :src="imgs.qc" class="qrcode-img" v-show="imgs.qc">
        <el-button type="primary" @click="download(imgs.qc, '前程信息采集专属二维码.png')">下载</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  name: 'InterviewQrcodeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    crmId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      dialogVisible: false,
      imgs: {
        jp: '', ko: '', sg: '', qc: ''
      },
    };
  },
  methods: {
    async getQrcode(id) {
      if (!id) {
        return false;
      }
      const { data } = await this.$http._post({
        url: '/index/student/createQr',
        data: { id }
      });
      this.imgs = data;
    },
    download(url, filename) {
      this.$http.getFile({ url, filename });
    },
    close() {
      this.$emit('update:visible', false);
    },
  },
  watch: {
    visible(v) {
      this.dialogVisible = v;
      if (!v) {
        this.imgs = { jp: '', ko: '', sg: '', };
      }
    },
    crmId(v) {
      this.getQrcode(v);
    }
  },
  destroyed() {
    this.dialogVisible = false;
  },
};
</script>
<style scoped>
  .qrcode-box {
    text-align: center;
  }
  .qrcode-img {
    width: 200px;
    height: 200px;
    display: block;
    margin: 0 auto;
    padding: 20px 0;
  }
</style>
